module.exports = [{
      plugin: require('/Users/christianpugliese/Documents/Code/Rytter/rider44web/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-12544427-8"},
    },{
      plugin: require('/Users/christianpugliese/Documents/Code/Rytter/rider44web/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
